// ==================== LICENSE KEY MANAGEMENT ====================
// Handles localStorage persistence of Polar license key activations.
// Validation happens via Vercel serverless functions at /api/*
// (same origin — no external server needed).

import { track } from './analytics';

const LICENSE_STORAGE_KEY = 'arrangementlab_license';

export function getLicenseInfo() {
  try {
    const stored = localStorage.getItem(LICENSE_STORAGE_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch {
    return null;
  }
}

export function isLicensed() {
  const info = getLicenseInfo();
  return info !== null && info.valid === true;
}

export function storeLicense(licenseData) {
  localStorage.setItem(LICENSE_STORAGE_KEY, JSON.stringify({
    valid: true,
    licenseKey: licenseData.licenseKey,
    activationId: licenseData.activationId,
    activatedAt: Date.now(),
  }));
  track('license_activated');
}

export function clearLicense() {
  localStorage.removeItem(LICENSE_STORAGE_KEY);
}

export async function validateLicenseKey(licenseKey) {
  const response = await fetch('/api/validate-license', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ licenseKey }),
  });
  return response.json();
}

export async function activateLicenseKey(licenseKey) {
  const response = await fetch('/api/activate-license', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ licenseKey, label: 'arrangementLab-web' }),
  });
  return response.json();
}

export async function deactivateLicenseKey(licenseKey, activationId) {
  const response = await fetch('/api/deactivate-license', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ licenseKey, activationId }),
  });
  return response.json();
}
